import { render, staticRenderFns } from "./TooltipIce.vue?vue&type=template&id=70782e6e&scoped=true"
import script from "./TooltipIce.vue?vue&type=script&lang=js"
export * from "./TooltipIce.vue?vue&type=script&lang=js"
import style0 from "./TooltipIce.vue?vue&type=style&index=0&id=70782e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70782e6e",
  null
  
)

export default component.exports